import axios from 'axios';

export const BASE_URL = process.env.REACT_APP_API_URL || 'https://api.beprime.pro';

export function createApiClient(token: string, onUnauthorized?: () => void) {
  const client = axios.create({
    baseURL: BASE_URL,
    headers: { 'X-Admin-Key': token },
  });

  client.interceptors.response.use(
    (res) => res,
    (err) => {
      if (err.response?.status === 401 && onUnauthorized) {
        onUnauthorized();
      }
      return Promise.reject(err);
    },
  );

  return client;
}
